import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  loadUserDetails,
  loadUserDetailsFailure,
  loadUserDetailsSuccess,
  updateUserDetails,
  updateUserDetailsFailure,
  updateUserDetailsSuccess
} from '../actions/user-details.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { UserCommonService } from '../../services/user.common.service';
import { SessionService } from '../../services/ssession.service';

@Injectable()
export class UserDetailsEffects {
  constructor(
    private actions$: Actions,
    private userCommonService: UserCommonService
  ) {
  }

  loadUserDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUserDetails),
      switchMap(action =>
        this.userCommonService.loadUserDetails().pipe(
          map(user => loadUserDetailsSuccess({ user })),
          catchError(() => of(loadUserDetailsFailure()))
        )
      )
    ) as any
  );

  updateUserDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateUserDetails),
      switchMap(action =>
        this.userCommonService.updateUserDetails(SessionService.GetTokenData()?.id || '', action.user)
          .pipe(
            map(user => {
              action.successFnc();
              return updateUserDetailsSuccess({ user });
            }),
            catchError(() => {
              action.failureFnc();
              return of(updateUserDetailsFailure());
            })
          )
      )
    ) as any
  );
}
